module.exports = __webpack_public_path__ + "site/img/12.364174ad.jpg";